module.exports = __webpack_public_path__ + "media/images/clients/alarm_bang-ac5d24732a86b6b712112c3a92fb7059.svg";